import {createSlice, PayloadAction,UnknownAction} from '@reduxjs/toolkit';
import {RootState} from './rootReducer'
import {persistReducer} from "redux-persist";
import storageSession from 'redux-persist/lib/storage/session';
import dayjs from 'dayjs';
import  isLeapYear from 'dayjs/plugin/isLeapYear' // import plugin
import 'dayjs/locale/en' // import locale
import 'dayjs/locale/es' // import locale
dayjs.extend(isLeapYear) // use plugin
dayjs.locale('en') // use locale
type variant = 'success' | 'warning' | 'info' | 'default' |'error';

interface app {
    backdrop: boolean,
    notifier:INotifier,
    url_with_param:string,
    date:any,
    idTour:string,
    back_url:string,
}


interface INotifier {
    open: boolean
    variant: variant,
    message: string
}

const initialState: app = {
    backdrop: false,
    notifier:{
        open: false,
        variant: 'default',
        message: ''
    },
    url_with_param:'',
    date:dayjs().format('YYYY-MM-DD'),
    idTour:'WTCZM001',
    back_url:'/'
};
const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        openBackdrop: (state) => {
            state.backdrop = true;
        },
        closeBackdrop: (state ) => {
            state.backdrop=initialState.backdrop
        },

        changeUrlFirst:(state,action:PayloadAction<string>)=>{
            state.url_with_param=action.payload
        },

        openNotifier: (state, {payload}: PayloadAction<INotifier>) => {
            state.notifier.open = payload.open;
            state.notifier.variant=payload.variant;
            state.notifier.message=payload.message
        },
        closeNotifier: (state ) => {
            state.notifier.open=initialState.notifier.open
        },
        changeIdTour:(state,action:PayloadAction<string>)=>{
            state.idTour=action.payload
        },
        changeDate:(state,action:PayloadAction<string>)=>{
            state.date=action.payload
        },
        changeBackUrl:(state,action:PayloadAction<string>)=>{
            state.back_url=action.payload
        },

        resetApp:(state, action)=>{
            // state.notifier=initialState.notifier,
            state.url_with_param=initialState.url_with_param
            state.date=initialState.date
            state.idTour=initialState.idTour
        }
    },
});

export const {changeBackUrl,resetApp,changeIdTour,changeDate,openBackdrop,closeBackdrop,changeUrlFirst,openNotifier,closeNotifier} = appSlice.actions

export const AppSelector = (state: RootState) => state.app
export const modalBookSelector = (state: RootState) => {
    return {
        region:state.app.region,
        date:state.app.date,
        child:state.app.child,
        adult:state.app.adult,
        idTour:state.app.idTour
    }
}

export const SubmitCartSelector = (state: RootState) => {
    return {
        submit_cart:state.app.submit_cart
    }
}

export const DialogSelector = (state: RootState) => {
    return {
        open_dialog:state.app.dialog.open,
        title_dialog:state.app.dialog.tittle,
        date_dialog:state.app.dialog.date,
        id_dialog:state.app.dialog.id,
        id_Horario:state.app.dialog.idHorario
    }
}
export const DialogErrorSelector = (state: RootState) => {
    return {
        open_dialog_error:state.app.dialog_error.open,
        title_dialog_error:state.app.dialog_error.tittle,
        button_dialog_error:state.app.dialog_error.button,
        type_dialog_error:state.app.dialog_error.type,
        paragraph_dialog_error:state.app.dialog_error.paragraph
    }
}
export const NotifierSelector = (state: RootState) => {
    return {
        open: state.app.notifier.open,
        variant: state.app.notifier.variant,
        message: state.app.notifier.message,
    }
}
export const modalSelector=(state: RootState)=>{
    return {
        pdc_amount: state.cart.cart.resume.amount,
        resume_currency:  state.cart.cart.resume.currency,
        resume_discount:  state.cart.cart.resume.discount,
        resume_subtotal:  state.cart.cart.resume.subtotal,
        resume_promotion: state.cart.cart.resume.promotion
    }
}
export const AppValidateSelector = (state: RootState) => {
    return {
        validate_cart: state.cart.cart.items.length>0,
        validate_form: state.client.is_valid,
        validate_payment: false,
    }
}
export const AppReducer = persistReducer({
    storage: storageSession,
    key: 'app',
    whitelist: ['url_with_param'],
    blacklist:['backdrop','dialog','notifier','submit_cart']
}, appSlice.reducer)
